import { render } from "./MainTutorialIcon3.vue?vue&type=template&id=9741413e&scoped=true&ts=true"
import script from "./MainTutorialIcon3.vue?vue&type=script&lang=ts"
export * from "./MainTutorialIcon3.vue?vue&type=script&lang=ts"

import "./MainTutorialIcon3.vue?vue&type=style&index=0&id=9741413e&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9741413e"]])

export default __exports__